var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.cancel,
      expression: "cancel"
    }],
    class: {
      'tw-relative tw-inline-block': _vm.trigger && !_vm.block,
      'tw-relative tw-block': _vm.trigger && _vm.block
    }
  }, [_vm.trigger ? _vm._t("trigger", function () {
    return [_c('b-button', {
      attrs: {
        "variant": "outline-secondary",
        "size": "sm",
        "block": _vm.block
      },
      on: {
        "click": _vm.toggle
      }
    }, [_c('b-icon', {
      staticClass: "tw-mr-1",
      attrs: {
        "icon": "calendar3"
      }
    }), _vm._v(" " + _vm._s(_vm.resolvedTriggerLabel) + " ")], 1)];
  }, {
    "toggle": _vm.toggle,
    "isOpen": _vm.isOpen,
    "label": _vm.resolvedTriggerLabel
  }) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.trigger || _vm.isOpen,
      expression: "!trigger || isOpen"
    }],
    class: {
      'tw-absolute tw-mt-1': _vm.trigger
    },
    style: _vm.trigger ? 'z-index: 20;' : null
  }, [_c('div', {
    staticClass: "picker-container"
  }, [_vm.showQuickSelect ? _c('div', {
    staticClass: "quick-select"
  }, _vm._l(_vm.quickSelectOptions, function (option) {
    return _c('div', {
      key: option.value,
      staticClass: "quick-option",
      class: {
        active: _vm.selectedQuickOption === option.value
      },
      on: {
        "click": function ($event) {
          return _vm.selectQuickOption(option);
        }
      }
    }, [_vm._v(" " + _vm._s(option.label) + " ")]);
  }), 0) : _vm._e(), _c('div', {
    staticClass: "calendar-section"
  }, [_c('div', {
    staticClass: "calendars"
  }, _vm._l(_vm.calendars, function (index) {
    return _c('div', {
      key: `calendar-${index}`,
      staticClass: "calendar"
    }, [_c('div', {
      staticClass: "calendar-header"
    }, [_c('button', {
      staticClass: "nav-btn",
      on: {
        "click": function ($event) {
          return _vm.previousMonth(index - 1);
        }
      }
    }, [_vm._v("‹")]), _c('span', {
      staticClass: "month-year tw-cursor-default"
    }, [_vm._v(_vm._s(_vm.formatMonthYear(_vm.currentMonths[index - 1])))]), _c('button', {
      staticClass: "nav-btn",
      on: {
        "click": function ($event) {
          return _vm.nextMonth(index - 1);
        }
      }
    }, [_vm._v("›")])]), _c('div', {
      staticClass: "calendar-grid"
    }, [_vm._l(_vm.weekDays, function (day) {
      return _c('div', {
        key: day,
        staticClass: "week-day"
      }, [_vm._v(_vm._s(day))]);
    }), _vm._l(_vm.getCalendarDates(index - 1), function (date) {
      return _c('div', {
        key: date.key,
        staticClass: "calendar-day",
        class: {
          'other-month': !date.currentMonth,
          'selected': _vm.isSelected(date.date),
          'in-range': _vm.isInRange(date.date),
          'range-start': _vm.isRangeStart(date.date),
          'range-end': _vm.isRangeEnd(date.date),
          'disabled': _vm.isDateDisabled(date.date)
        },
        on: {
          "click": function ($event) {
            return _vm.selectDate(date.date);
          },
          "mouseenter": function ($event) {
            _vm.hoverDate = date.date;
          }
        }
      }, [_vm._v(" " + _vm._s(date.day) + " ")]);
    })], 2)]);
  }), 0), _c('div', {
    staticClass: "footer"
  }, [_vm.calendars === 2 ? _c('div', {
    staticClass: "date-inputs"
  }, [_c('input', {
    staticClass: "date-input",
    attrs: {
      "type": "text",
      "readonly": "",
      "placeholder": "Start date"
    },
    domProps: {
      "value": _vm.formatDate(_vm.startDate)
    }
  }), _c('span', {
    staticClass: "separator"
  }, [_vm._v("-")]), _c('input', {
    staticClass: "date-input",
    attrs: {
      "type": "text",
      "readonly": "",
      "placeholder": "End date"
    },
    domProps: {
      "value": _vm.formatDate(_vm.endDate)
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "actions"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm"
    },
    on: {
      "click": _vm.apply
    }
  }, [_vm._v("Apply")])], 1)])])])])], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };